module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-building-p-26dd74fbdd0b36134660bc0cd3f9f222.svg";